import { useEffect } from 'react'
import withRouterActions from 'routes/utils/withRouterActions'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import RoutesHelper from 'helpers/RoutesHelper'
import { getFirstChannelId } from 'data/channels/selectors'
import { getLastVisitedNoteIds } from 'data/userPreferences/selectors'
import { isOwnerOnboardingActive } from 'screens/OnboardingPopover/utils'

const RedirectToRoot = ({
  routerReplace,
  firstChannelId,
  lastVisitedNoteId,
  redirectToOwnerOnboarding,
}) => {
  useEffect(
    () => {
      if (redirectToOwnerOnboarding) {
        routerReplace(RoutesHelper.ownerOnboarding())
        return
      }
      if (lastVisitedNoteId) {
        routerReplace(RoutesHelper.noteShow({ noteId: lastVisitedNoteId }))
        return
      }
      if (firstChannelId) {
        routerReplace(
          RoutesHelper.noteChannelIndex({ channelId: firstChannelId })
        )
        return
      }
      routerReplace(RoutesHelper.filterShow({ filterId: 'all' }))
    },
    [
      firstChannelId,
      lastVisitedNoteId,
      routerReplace,
      redirectToOwnerOnboarding,
    ]
  )
  return null
}

export default compose(
  withRouterActions,
  connect(state => ({
    firstChannelId: getFirstChannelId(state),
    lastVisitedNoteId: getLastVisitedNoteIds(state).first(),
    redirectToOwnerOnboarding: isOwnerOnboardingActive(state),
  }))
)(RedirectToRoot)
